export default "__VITE_ASSET__DyIUdgXX__"